export const INITIAL_SCAN_DELAY_MS = 500;
export const MUTATION_DEBOUNCE_MS = 200;
export const INDICATOR_CONTAINER_ATTR = 'data-enrichment-indicator';

export const POPOVER_ANCHOR_ORIGIN = { vertical: 'top', horizontal: 'center' };
export const POPOVER_TRANSFORM_ORIGIN = { vertical: 'bottom', horizontal: 'center' };
